import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Tooltip,
  TextField,
  InputAdornment,
  CircularProgress,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

interface ConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (password?: string) => void;
  title: string;
  agentName?: string; // Optional additional title
  message: string;
  password?: boolean; // Optional prop for password
  mail?: string; // Optional prop for email
  confirmButtonText?: string;
  confirmButtonColor?: 'primary' | 'secondary' | 'error' | 'success' | 'warning';
  isLoading?: boolean; // Optional loading state
  loadingText?: string; // Optional loading text
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  agentName,
  message,
  password, // Default to false if not provided
  mail,
  confirmButtonText = 'Confirm',
  confirmButtonColor = 'primary',
  isLoading = false,
  loadingText,
}) => {
  const [passwordValue, setPasswordValue] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleConfirm = () => {
    if (password) {
      onConfirm(passwordValue);
    } else {
      onConfirm();
    }
    setPasswordValue("");
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      // PaperProps={{
      //   sx: {
      //     width: 350,
      //     height: 250,
      //     display: 'flex',
      //     flexDirection: 'column',
      //     justifyContent: 'center',
      //     alignItems: 'center',
      //   },
      // }}
      sx={{
        "& .MuiDialog-paper": {
          position: "absolute",
          top: "50%",
          left: "50%",
          width: "360px",
          height: password ? "350px" : "250px",
          borderRadius: "4px",
          transform: "translate(-50%, -50%)",
          // padding: "10px 10px 0",
          padding: "10px",
          boxSizing: "border-box",
          overflow: "hidden", // ✅ Prevent scrollbars
        },
      }}
    >
      <DialogTitle
        sx={{
          textAlign: "center",
          fontWeight: 700,
          fontSize: "16px",

        }}
      >
        <b>{title}</b>

      </DialogTitle>
      <DialogContent
        sx={{
          textAlign: "center",
          fontWeight: 400,
          fontSize: "14px",
          color: "#667085",
          mt: "8px",
          ml: "8px",
          overflow: "visible", // prevent scrollbar
          maxHeight: "none", // override default
        }}
      >
        <Typography>{message}</Typography>
        <Typography sx={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          // fontWeight: "bold",
          flex: 1,
        }} title={mail}>{mail}</Typography>
        {password && (
          <form autoComplete="off">
            <TextField
              label="Password"
              type={showPassword ? "text" : "password"}
              fullWidth
              value={passwordValue}
              onChange={e => setPasswordValue(e.target.value)}
              error={!!passwordError}
              helperText={passwordError}
              margin="normal"
              sx={{
                "& .MuiOutlinedInput-root": {
                  ...(!showPassword && { font: "initial" }),
                },
              }}

              slotProps={{
                input: {
                  endAdornment: (
                    <InputAdornment position="end">
                      <span className="visibility-icon">
                        {showPassword ? (
                          <Visibility
                            onClick={() => setShowPassword(!showPassword)}
                          />
                        ) : (
                          <VisibilityOff
                            onClick={() => setShowPassword(!showPassword)}
                          />
                        )}
                      </span>
                    </InputAdornment>
                  ),
                },
              }}
            />
          </form>

        )}
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: "12px",
          paddingBottom: "24px",
          marginTop: "12px",
        }}
      >
        <Button
          onClick={handleConfirm}
          color={confirmButtonColor}
          variant="outlined"
          disabled={isLoading}
          startIcon={isLoading ? <CircularProgress size={16} sx={{ color: '#FFFFFF' }} /> : null}
          sx={{
            width: "130px",
            height: "36px",
            backgroundColor: confirmButtonColor == 'error' ? "#FF5A5F" : "blue",
            color: "#FFFFFF",
            textTransform: "none",
            "&:hover": {
              backgroundColor: confirmButtonColor == 'error' ? "#e14d50" : "",
            },
            "&:disabled": {
              backgroundColor: confirmButtonColor == 'error' ? "#FF5A5F" : "blue",
              color: "#FFFFFF",
              opacity: 0.7,
            },
          }}
        >
          {isLoading ? (loadingText || 'Deleting...') : confirmButtonText}
        </Button>
        <Button
          onClick={onClose}
          variant="outlined"
          disabled={isLoading}
          sx={{
            width: "130px",
            height: "36px",
            //color: confirmButtonColor!=="error"?"#5C5589":"#FF5A5F",
            //backgroundColor: "#FFFFFF",
            borderColor: "#696595",
            textTransform: "none",
            //backgroundColor: confirmButtonColor!=='error'? "blue":"#FF5A5F",
            color: "#696595",
            // textTransform: "none",
            "&:hover": {
              backgroundColor: confirmButtonColor == 'error' ? "" : "#e14d50",
            },
          }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;